import React from "react";
import { Outlet } from "react-router-dom";

const TvScreenLayout = () => {
   return (
      <div className="tvScreen">
         <Outlet />
      </div>
   );
};

export default TvScreenLayout;
